import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class SupportService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getSalesRep() {
        const url = this.urlsService.getUrl(this.urlsService.SALES_SUPPORT.SALES_REP);
        return this.ajaxService.getDataObserveBody(url);
    }
    getPageCategories(page) {
        const url = this.urlsService.getUrl(this.urlsService.SUPPORT.CATEGORY, { page });
        return this.ajaxService.getDataObserveBody(url);
    }
    getWebinars() {
        const url = this.urlsService.SUPPORT.WEBINARS;
        return this.ajaxService.getDataObserveBody(url);
    }
}
SupportService.ɵfac = function SupportService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SupportService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
SupportService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SupportService, factory: SupportService.ɵfac, providedIn: 'root' });
